import React from "react";
import CurrencySwitch from "../common/CurrencySwitch";
import { fmt } from "../../services/formatting";

/**
 * Stats display grid component
 */
export const StatsDisplay = ({
  stats,
  filteredCount,
  totalCount,
  activeFilters,
  displayCurrency,
  onDisplayCurrencyChange,
}) => {
  const getValueClass = (color) =>
    color === "var(--app-positive)"
      ? "stat-card__value stat-card__value--positive"
      : color === "var(--app-danger)"
        ? "stat-card__value stat-card__value--danger"
        : color === "var(--app-accent-2)"
          ? "stat-card__value stat-card__value--accent"
          : "stat-card__value";

  const statsConfig = [
    {
      label: "Inscrições",
      value: stats.totalInsc,
      sub: "total c/ rebuys",
      icon: "♣",
    },
    {
      label: "ABI",
      value: fmt(stats.abi, displayCurrency),
      sub: "avg buy-in",
      icon: "♦",
    },
    {
      label: "Total Ganho",
      value: fmt(stats.totalGanho, displayCurrency),
      sub: "em prêmios",
      icon: "♥",
    },
    {
      label: "Lucro",
      value: fmt(stats.totalGanho - stats.totalInvestido, displayCurrency),
      sub: "resultado geral",
      icon: "♠",
      color:
        stats.totalGanho - stats.totalInvestido >= 0
          ? "var(--app-positive)"
          : "var(--app-danger)",
    },
    {
      label: "ROI",
      value: `${stats.roiPos ? "+" : ""}${stats.roi}%`,
      sub: "retorno",
      icon: "♠",
      color: stats.roiPos ? "var(--app-positive)" : "var(--app-danger)",
    },
    {
      label: "KO %",
      value: `${stats.koPct}%`,
      sub: "KO + PKO jogados",
      icon: "♣",
      color: "var(--app-accent-2)",
    },
  ];

  return (
    <>
      <div className="stats-currency-row">
        <CurrencySwitch
          displayCurrency={displayCurrency}
          onChange={onDisplayCurrencyChange}
        />
      </div>
      <div className="stats-grid">
        {statsConfig.map((s, i) => (
          <div
            key={i}
            className={`sc ${activeFilters ? "sc--filtered" : ""}`}
          >
            <div className="stat-card__inner">
              <div>
                <div className="stat-card__label">
                  {s.label}
                </div>
                <div className={getValueClass(s.color)}>
                  {s.value}
                </div>
                <div className="stat-card__sub">
                  {s.sub}
                </div>
              </div>
              <div className="stat-card__icon">
                {s.icon}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

/**
 * Satellite stats display grid
 */
export const SatelliteStatsDisplay = ({ stats, displayCurrency }) => {
  const getValueClass = (color) =>
    color === "var(--app-positive)"
      ? "stat-card__value stat-card__value--positive"
      : color === "var(--app-danger)"
        ? "stat-card__value stat-card__value--danger"
        : color === "var(--app-accent-2)"
          ? "stat-card__value stat-card__value--accent"
          : "stat-card__value";

  const satStatsConfig = [
    { label: "Inscrições SAT", value: stats.satTotal, sub: "entradas em satélites", icon: "♣" },
    { label: "Investido SAT", value: fmt(stats.satTotalInvestido, displayCurrency), sub: "buy-in", icon: "♠" },
    {
      label: "Lucro SAT",
      value: fmt(stats.satLucro, displayCurrency),
      sub: "resultado",
      icon: "♦",
      color: stats.satLucro >= 0 ? "var(--app-positive)" : "var(--app-danger)",
    },
    {
      label: "ROI SAT",
      value: `${stats.satRoiPos ? "+" : ""}${stats.satRoi}%`,
      sub: "retorno",
      icon: "♠",
      color: stats.satRoiPos ? "var(--app-positive)" : "var(--app-danger)",
    },
    {
      label: "ITM",
      value: `${stats.itmPct}%`,
      sub: "registros premiados",
      icon: "%",
      color: "var(--app-accent-2)",
    },
  ];

  return (
    <div className="stats-grid stats-grid--satellite">
      {satStatsConfig.map((s, i) => (
        <div
          key={i}
          className="sc sc--filtered"
        >
          <div className="stat-card__inner">
            <div className="stat-card__body">
              <div className="stat-card__label">
                {s.label}
              </div>
              <div className={getValueClass(s.color)}>
                {s.value}
              </div>
              <div className="stat-card__sub">
                {s.sub}
              </div>
            </div>
            <div className="stat-card__icon">
              {s.icon}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsDisplay;
